import { render, staticRenderFns } from "./PivotCell.vue?vue&type=template&id=cbc93b28&scoped=true"
import script from "./PivotCell.vue?vue&type=script&lang=js"
export * from "./PivotCell.vue?vue&type=script&lang=js"
import style0 from "./PivotCell.vue?vue&type=style&index=0&id=cbc93b28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc93b28",
  null
  
)

export default component.exports